import * as React from 'react';
import { cn } from '@/lib/utils';

export interface MobileListProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * 是否使用強化的樣式
   */
  strong?: boolean;
  /**
   * 是否使用內邊距
   */
  inset?: boolean;
}

/**
 * iOS 風格列表容器
 * 用於包裹列表項目，提供 iOS 風格的圓角、陰影和內邊距
 */
export const MobileList = React.forwardRef<HTMLDivElement, MobileListProps>(
  ({ className, strong = false, inset = false, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'bg-white rounded-2xl overflow-hidden',
          strong
            ? 'shadow-lg border border-gray-200'
            : 'shadow-sm border border-gray-100',
          inset ? 'p-2' : 'p-0',
          className
        )}
        {...props}
      />
    );
  }
);
MobileList.displayName = 'MobileList';
